import { BoolTreeNode } from 'src/app/shared/classes/bool-tree-node';
import { EMPTY_ARRAY } from 'src/app/shared/constants/empty-array';
import { Injectable } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

type Attrs<T> = { label: string; value: T };

@Injectable()
export class CheckboxFilterService<T> {
  private readonly onReset$ = new Subject<void>();
  private readonly _onCheck$ = new Subject<void>();
  private boolTree: BoolTreeNode<Attrs<T>> = null!;
  private readonly computed: {
    selectedValues?: T[];
  } = { };

  public readonly onCheck$ = this._onCheck$.asObservable();

  get root(): BoolTreeNode<Attrs<T>> {
    return this.boolTree;
  }

  get children(): Readonly<BoolTreeNode<Attrs<T>>[]> | undefined {
    return this.boolTree?.children ?? EMPTY_ARRAY;
  }

  get selectedChildren(): Readonly<BoolTreeNode<Attrs<T>>[]> {
    return this.boolTree?.selectedChildren ?? EMPTY_ARRAY;
  }

  set selectedChildren(value: Readonly<BoolTreeNode<Attrs<T>>[]>) {
    this.selectedValues = value.map((s) => s.attrs.value);
  }

  get selectedValues(): T[] {
    return this.computed.selectedValues ?? EMPTY_ARRAY;
  }

  set selectedValues(value: T[]) {
    for (const record of this.boolTree.children) {
      record.value = value.includes(record.attrs.value);
    }
  }

  public reset(root: Attrs<T>, attrs: Attrs<T>[]): void {
    this.onReset$.next();

    this.boolTree = new BoolTreeNode({
      attrs: root,
      value: attrs.map(
        (a) =>
          new BoolTreeNode({
            attrs: a,
          }),
      ),
    });

    this.boolTree.onCheck$.pipe(takeUntil(this.onReset$)).subscribe(() => {
      this._onCheck$.next();
      this.computed.selectedValues = this.selectedChildren.map(
        (s) => s.attrs.value,
      );
    });
  }
}
